import { formatDates, replaceUndefinedWithNull } from '~/utils/dateFormatter'

const dateFields = [
  'renovation_planned_at',
  'building_law_end_date',
  'financial_value_estimation_date',
  'object_financing_deadline',
  'purchase_date',
]

export const state = () => ({
  object: null,
})

export const actions = {
  async load({ commit }, { customerId, id }) {
    const { data } = await this.$axios.$get(
      `customers/${customerId}/objects/${id}`
    )

    commit('setObject', data)
    commit('mortgages/setMortgage', data.mortgage, { root: true })

    return data
  },

  async create({ commit }, { customerId, data }) {
    const object = await await this.$axios.$post(
      `customers/${customerId}/objects`,
      data
    )
    commit('setObject', object.data)
    return object.data
  },

  async update({ commit }, { id, customerId, data }) {
    const customer = await this.$axios.$patch(
      `customers/${customerId}/objects/${id}`,
      data
    )
    commit('setObject', customer.data)
    return customer.data
  },

  async destroy({ commit }, { customerId, id }) {
    await this.$axios.$delete(`customers/${customerId}/objects/${id}`)
    commit('setObject', null)
  },

  async pricehubble({ commit, dispatch }, { customerId, id }) {
    const response = await this.$axios.$post(
      `customers/${customerId}/objects/${id}/integrations/pricehubble`
    )
    if (response.success) {
      dispatch('load', { customerId, id })
    }
    return response
  },

  async save(
    { dispatch, commit },
    { customerId, id, data, renovationAutofilledFinancingFields = [] }
  ) {
    data = formatDates(this.$dateFns, data, dateFields)
    data = replaceUndefinedWithNull(data)

    const objectData = {
      ...data,
      customer_id: data.customer?.id || customerId,
      pension_fund_type: data.pension_fund_type?.value || null,
      third_pillar_type: data.third_pillar_type?.value || null,
    }

    try {
      let object
      if (id) {
        object = await dispatch('update', { id, customerId, data: objectData })
        commit('setObject', object)
      } else {
        object = await dispatch('create', { data: objectData, customerId })
      }
      dispatch(
        'alerts/raiseAlert',
        { message: 'Speichern erfolgreich!' },
        { root: true }
      )

      const autofilledFieldLabels = {
        mortgage_increase: 'Erhöhung',
        mortgage_increase_purpose: 'Zweck der Hypothekarerhöhung',
      }
      const changedLabels = renovationAutofilledFinancingFields
        .map((field) => autofilledFieldLabels[field])
        .filter(Boolean)

      if (changedLabels.length > 0) {
        const fields =
          changedLabels.length === 1
            ? changedLabels[0]
            : `${changedLabels.slice(0, -1).join(', ')} und ${
                changedLabels[changedLabels.length - 1]
              }`

        dispatch(
          'alerts/raiseAlert',
          {
            message: `${fields} ${
              changedLabels.length === 1 ? 'wurde' : 'wurden'
            } aufgrund der geplanten Renovationen automatisch aktualisiert.`,
            autoHide: 5000,
          },
          { root: true }
        )
      }

      return object
    } catch (e) {
      const details = e.response?.data?.error?.message ?? e.response?.data
      dispatch(
        'alerts/raiseAlert',
        { message: 'Speichern fehlgeschlagen!', state: 'error', details },
        { root: true }
      )
      throw e
    }
  },
}

export const mutations = {
  setObject(state, value) {
    state.object = value
  },

  addDocument(state, document) {
    if (!state.object) {
      return
    }

    if (!state.object.documents) {
      state.object.documents = []
    }
    state.object.documents.push(document)
  },
}

export const getters = {
  object: (state) => state.object,
}
